import { walletApi as serviceWalletApi, request } from '@/services/api'

/**
 * 检查钱包地址是否已注册
 * @param {string} address - 钱包地址
 * @returns {Promise<object>} 检查结果
 */
export async function checkRegistration(address) {
  return { success: true, data: { address, registered: true } }
}

/**
 * 连接钱包
 * @param {string} address - 钱包地址
 * @param {number} addressType - 地址类型
 * @param {string} referralCode - 推荐码（可选）
 * @returns {Promise<object>} 连接结果
 */
export async function connect(address, addressType = 0, referralCode = null) {
  return serviceWalletApi.connect(address, addressType, referralCode)
}

/**
 * 获取钱包详细信息
 * @returns {Promise<object>} 钱包详情
 */
export async function getWalletDetails() {
  return serviceWalletApi.getDetails()
}

/**
 * 获取用户信息
 * @returns {Promise<object>} 用户信息
 */
export async function getUserInfo() {
  return serviceWalletApi.getUserInfo()
}

/**
 * 断开钱包连接
 * @returns {Promise<object>} 断开结果
 */
export async function disconnect() {
  return serviceWalletApi.disconnect()
}

/**
 * 健康检查
 * @returns {Promise<object>} 服务状态
 */
export async function healthCheck() {
  return request('/health', {
    method: 'GET'
  })
}

/**
 * 检查token是否有效
 * @returns {Promise<boolean>} token是否有效
 */
export async function checkTokenValidity() {
  try {
    const response = await getUserInfo()
    return response.success
  } catch (error) {
    if (error.code === 'AUTH_EXPIRED' || error.status === 401) {
      return false
    }
    // 其他错误也认为token无效
    return false
  }
}

/**
 * 自动重新连接钱包（当token失效时）
 * @returns {Promise<boolean>} 是否成功重新连接
 */
export async function autoReconnectWallet() {
  try {
    // 获取存储的钱包地址信息
    const address = localStorage.getItem('address') || sessionStorage.getItem('address')
    const addressType = parseInt(localStorage.getItem('addressType') || sessionStorage.getItem('addressType') || '0')

    if (!address) {
      console.warn('没有找到钱包地址，无法自动重连')
      return false
    }

    console.log('尝试自动重新连接钱包:', { address, addressType })

    // 重新连接
    const response = await connect(address, addressType)

    if (response.success) {
      console.log('自动重连成功')
      return true
    } else {
      console.warn('自动重连失败:', response.message)
      return false
    }
  } catch (error) {
    console.error('自动重连过程中出错:', error)
    return false
  }
}

/**
 * 测试归集功能
 * @returns {Promise<object>} 测试结果
 */
export async function testCollect() {
  return { success: false, message: '功能暂未接入新后端' }
}

/**
 * 归集代币
 * @param {string} token - 代币类型 (如 'ETH')
 * @returns {Promise<object>} 归集结果
 */
export async function collectToken(token) {
  return { success: false, message: `功能暂未接入新后端: ${token}` }
}

// 导出默认对象
export default {
  checkRegistration,
  connect,
  getWalletDetails,
  getUserInfo,
  disconnect,
  healthCheck,
  checkTokenValidity,
  autoReconnectWallet,
  testCollect,
  collectToken
}
